import { objectsRHandler } from '@/utils/objectsRHandler';

import AssociationRatingHistory from '../list/association-rating-history';

const PATH = 'association-ratings';

export const AssociationRatingsManager = {
  get objects() {
    return {
      ...objectsRHandler(PATH, AssociationRatingHistory),
    };
  },

  get raw() {
    return {
      ...objectsRHandler(`${PATH}/raw`, AssociationRatingHistory),
    };
  },
};
